import { AppEnv, publicRuntimeConfig } from "@fanfanlo"
import { HomeGlobalDevContent } from "./HomeGlobalDevContent"
import { HomeGlobalStagingContent } from "./HomeGlobalStagingContent"
import { HomeGlobalProdContent } from "./HomeGlobalProdContent"


function Global(){
    return (
        <>
        {publicRuntimeConfig.env === AppEnv.Dev && <HomeGlobalDevContent/>}
        {publicRuntimeConfig.env === AppEnv.Staging && <HomeGlobalStagingContent/>}
        {publicRuntimeConfig.env === AppEnv.Prod && <HomeGlobalProdContent/>}
        </>
    )
}

function Cn(){
    return(
        <div>cn</div>
    )
}

export function HomeContent() {

    return (<>
    {publicRuntimeConfig.region === "global" && <Global/>}
    {publicRuntimeConfig.region === "zh-cn" && <Cn/>}
    </>)
}